import useMedia from 'use-media';
import {Stack} from '@treatwell/ui';
import {GridLayout, GridLayoutContent, GridLayoutSide} from '../../pages';
import {OrderTotalContainer} from '../OrderTotal/OrderTotal';
import {RescheduleOrderSubmitContainer} from '../Submit';
import {DepositContainer} from '../Deposit/Deposit';
import styles from './FixedFooterDeposits.module.css';

export const FixedFooterDeposits = () => {
  const isMobile = useMedia({maxWidth: 699});
  const type: 'bodyHeavy' | 'mdHeader' = isMobile ? 'bodyHeavy' : 'mdHeader';

  return (
    <div className={styles.container} data-cy="StickyFooterDeposits">
      <GridLayout>
        <GridLayoutContent inline>
          <Stack>
            <DepositContainer compact />
            <OrderTotalContainer align="start" type={type} />
          </Stack>
        </GridLayoutContent>
        <GridLayoutSide inline>
          <div className={styles.submitButton}>
            <RescheduleOrderSubmitContainer />
          </div>
        </GridLayoutSide>
      </GridLayout>
    </div>
  );
};
